const es = {
  language: "Idioma",
  english: "Inglés",
  portuguese: "Portugués",
  spanish: "Español",
  logout: "Salir",
  login: "Login",
  loginPage: "Accesso",
  welcome: "Bienvenido",
  save: "Salvar",
  backToSearch: "Volver a la búsqueda",
  backToDetails: "Volver a los detalles",
  delete: "Borrar",
  update: "Actualizar",
  edit: "Editar",
  new: "Nuevo",
  newA: "Nuevo (a)",
  search: "Buscar",
  total: "Total",
  itensFound: "artículos encontrados",
  registersPerPage: "registros por página",
  ofPages: "de {0} páginas",
  yes: "Sí",
  no: "No",
  select: "Seleccionar",
  name: "Nombre",
  code: "Código",
  close: "Cerrar",
  date: "Fecha",
  user: "Usuario",
  details: "Detalles",
  email: "Email",
  column: "Columna",
  warning: "Aviso",
  menu: "Menú",
  form: "Form",
  itemSuccessfullyCreated: "Elemento creado correctamente",
  itemSuccessfullyUpdated: "Elemento actualizado correctamente",
  confirmTheDeletion: "¿Confirma la eliminación?",
  itemDeleted: "Elemento eliminado.",
  error: "Error",
  unexpectedError: "¡Error inesperado!",
  anUnexpectedErrorOccurred: "Ocurrió un error inesperado:",
  theUrlAccessedDoesNotBelongToAnyTenant: "The URL accessed does not belong to any Tenant",
  success: "Éxito",
  value: "Value",
  label: "Label",
  maximumSize: "Tamaño máximo",
  maximumValue: "Valor máximo",
  minimumSize: "Tamaño mínimo",
  minimumValue: "Valor mínimo",
  required: "Necesario",
  suffix: "Sufijo",
  users: "Usuarios",
  backToList: "Volver a la lista",
  phone: "Teléfono",
  enabled: "¿Autorizado?",
  noItemsFound: "No se encontraron artículos",
  item: "Item",
  contactUs: "Contacto",
  cpf: "CPF",
  cnpj: "CNPJ",
  invalid: "inválido",
  pleaseFillInTheField: "Por favor, rellene el campo",
  bothFieldsAreRequired: "¡Ambos los campos son obligatorio!",
  profile: "Perfil",
  changePassword: "Cambiar la contraseña",
  currentPassword: "Contraseña actual",
  newPassword: "Nueva contraseña",
  repeatNewPassword: "Repita la nueva contraseña",
  passwordExpired: 'Contraseña expirada',


  username: "Nombre de usuario",
  password: "Contraseña",
  documentNumber: "Número de documento",
  actions: 'Acciones',
  chooseAFile: 'Elige un archivo.',
  version: 'Versión',
  sgs_render_file_error_upload: "Ocurrió un error, el archivo no fue subido"
};

export default {
  ...es
};



// WEBPACK FOOTER //
// ./src/i18n/es.js